// src/ApiPanel/pages/ApiPanelDashboard.jsx
import React, { useEffect, useState } from "react";
import { apiPanelFetch } from "../utils/apiPanelFetch";
import { API_PANEL_ENDPOINTS } from "../constants/apiPanelAuth";
import { useApiPanelSession } from "../context/ApiPanelSessionContext";

export default function ApiPanelDashboard() {
  const { user } = useApiPanelSession();
  const [loginHistory, setLoginHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiPanelFetch(API_PANEL_ENDPOINTS.LOGIN_HISTORY)
      .then((res) => {
        if (!cancelled) setLoginHistory(res?.data || []);
      })
      .catch(() => {
        /* non-fatal — dashboard still renders without history */
      })
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="apip-dashboard">
      <h1 className="apip-page-title">Welcome{user?.name ? `, ${user.name}` : ""}</h1>

      <div className="apip-card">
        <div className="apip-card-header">Recent Logins</div>

        {loading ? (
          <div className="apip-loading">Loading…</div>
        ) : loginHistory.length === 0 ? (
          <div className="apip-empty">No login history yet.</div>
        ) : (
          <div className="apip-table-wrap">
            <table className="apip-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Login Time</th>
                  <th>IP Address</th>
                  <th>Browser</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {loginHistory.map((row, i) => (
                  <tr key={row.id ?? i}>
                    <td>{row.user_name}</td>
                    <td>{row.login_time}</td>
                    <td>{row.ip_address}</td>
                    <td>{row.browser}</td>
                    <td>{row.location}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
